import _ from 'lodash';
import moment from 'moment-timezone';
import { GOAL_LEAD_GENERATION, GOAL_LOCAL_OFFERS, GOAL_REACH_FREQUENCY, GOAL_REACH_AND_CLICK, GOAL_POST_ENGAGEMENT } from '@/util/constants';

export function apiToLocalDate(momentObj) {
  if (!momentObj) {
    return null;
  }

  let obj = momentObj;
  if (obj !== null && typeof obj !== 'object') {
    obj = moment(momentObj);
  }

  return new Date(
      obj.year(),
      obj.month(),
      obj.date(),
      obj.hours(),
      obj.minutes(),
      obj.seconds(),
  );
}

export function localDateToApi(dateObj) {
  if (!dateObj) {
    return null;
  }

  return moment()
    .year(dateObj.getFullYear())
    .month(dateObj.getMonth())
    .date(dateObj.getDate())
    .hours(dateObj.getHours())
    .minutes(dateObj.getMinutes())
    .seconds(dateObj.getSeconds())
    .milliseconds(0);
}

// Taken from https://stackoverflow.com/a/5997959
export function findUrlsInText(text) {
  const source = (text || '').toString();
  const urlArray = [];
  let matchArray;

  // Regular expression to find FTP, HTTP(S) and email URLs.
  const regexToken = /(((ftp|https?):\/\/)[-\w@:%_+.~#?,&//=]+)|((mailto:)?[_.\w-]+@([\w][\w-]+\.)+[a-zA-Z]{2,3})/g;

  // Iterate through any URLs in the text.
  matchArray = regexToken.exec(source);
  while (matchArray !== null) {
    const token = matchArray[0];
    urlArray.push(token);
    matchArray = regexToken.exec(source);
  }

  return urlArray;
}

export function getDisplayedStatsKeys(campaignGoalType, advancedStats, overall) {
  if (advancedStats && overall) {
    if (campaignGoalType === GOAL_LEAD_GENERATION) {
      return ['reach', 'leadgen_other', 'total_clicks', 'engagement_rate'];
    } else if (campaignGoalType === GOAL_LOCAL_OFFERS) {
      return ['reach', 'unique_clicks', 'receive_offer', 'clicks', 'engagement_rate', 'post_engagement', 'page_engagement'];
    } else if ([GOAL_REACH_FREQUENCY, GOAL_POST_ENGAGEMENT].includes(campaignGoalType)) {
      return ['reach', 'frequency', 'total_clicks', 'engagement_rate'];
    } else if (campaignGoalType === GOAL_REACH_AND_CLICK) {
      return ['reach', 'total_clicks', 'engagement_rate'];
    }
    return ['reach', 'impressions', 'clicks', 'engagement_rate', 'post_engagement', 'page_engagement'];
  }

  if (advancedStats && !overall) {
    if (campaignGoalType === GOAL_LEAD_GENERATION) {
      return ['reach', 'leadgen_other', 'impressions', 'engagement_rate', 'total_clicks'];
    } else if (campaignGoalType === GOAL_LOCAL_OFFERS) {
      return ['reach', 'unique_clicks', 'receive_offer', 'clicks', 'engagement_rate', 'post_engagement', 'page_engagement'];
    } else if ([GOAL_REACH_FREQUENCY, GOAL_POST_ENGAGEMENT].includes(campaignGoalType)) {
      return ['reach', 'frequency', 'engagement_rate', 'total_clicks', 'impressions', 'page_engagement', 'post_engagement'];
    } else if (campaignGoalType === GOAL_REACH_AND_CLICK) {
      return ['reach', 'impressions', 'engagement_rate', 'total_clicks', 'page_engagement', 'post_engagement'];
    }
    return ['reach', 'impressions', 'clicks', 'engagement_rate', 'post_engagement', 'page_engagement'];
  }

  if (campaignGoalType === GOAL_LEAD_GENERATION) {
    return ['reach', 'leadgen_other', 'clicks', 'engagement_rate'];
  } else if (campaignGoalType === GOAL_LOCAL_OFFERS) {
    return ['reach', 'unique_clicks', 'receive_offer', 'clicks', 'engagement_rate'];
  } else if (campaignGoalType === GOAL_REACH_AND_CLICK) {
    return ['reach', 'total_clicks', 'engagement_rate'];
  }

  return ['reach', 'frequency', 'clicks', 'engagement_rate'];
}

export function getCampaignStatsDetails(key, stats, campaignGoalType, campaignType) {
  let data = null;
  if (key === 'post_engagement') {
    data = [
      {
        name: 'post_reaction',
        value: _.get(stats, 'post_reaction', 0),
      },
      {
        name: 'comment',
        value: _.get(stats, 'comment', 0),
      },
      {
        name: 'post',
        value: _.get(stats, 'post', 0),
      },
    ];
    if (campaignType === 'video') {
      data.push({
        name: 'video_view',
        value: _.get(stats, 'video_view', 0),
      });
    }
  }
  if (key === 'total_clicks') {
    data = [
      {
        name: campaignGoalType === GOAL_LEAD_GENERATION ? 'form_openings' : 'landing_clicks',
        value: _.get(stats, 'link_click', 0),
      },
      {
        name: 'other',
        value: _.get(stats, 'clicks', 0) - _.get(stats, 'link_click', 0),
      },
    ];
  }
  return data;
}



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/utils/helper.js